import React from "react";
import { withWrapper } from "create-react-server/wrapper";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import banner_top from "modules/banner_top";

import Banner from "components/Banner/Banner";
import TopBanner from "components/TopBanner";
import Magazine from "components/Magazine/Magazine";
import FavoriteLibraries from "components/FavoriteLibraries/FavoriteLibraries";
import Controls from "components/Controls";

import dataFormatter from "utils/dataFormatter";

import "./Main.css";

class Main extends React.Component {
  componentWillMount() {
    this.props.getTopBanner();
  }

  render() {
    const { banner_top } = this.props;

    return (
      <div className="content">
        <div className="information-table">
          <div className="main-title width-2">
            Добро пожаловать на сайт библиотек Москвы!
          </div>
          <div className="width-2">
            <div className="description">
              Здесь вы можете начать свое знакомство с возможностями, которые
              открывают для вас городские библиотеки.
            </div>
            <div className="description">
              В Москве более 400 городских библиотек — городских гостиных, в
              которых рады каждому.
            </div>
          </div>
        </div>
        {banner_top &&
          dataFormatter(banner_top).map((item, i) => (
            <TopBanner key={i} banner_top={item} />
          ))}
        <Magazine />
        <Banner bannerId={0} />
        <Banner bannerId={1} />
        <div className="information-table">
          <div className="col-narrow">
            <span className="underline-title underline-title--no_underline">
              В библиотеках Москвы вы найдете:
            </span>
          </div>
          <div className="col-wide">
            <div className="list-item">
              <div>
                <div className="icon-book" />
              </div>
              <div>
                Большое разнообразие литературы, которую можно читать в зале или
                взять домой совершенно бесплатно. Библиотекари и библиографы
                помогут подобрать нужные издания. А через стационарный компьютер
                или wi-fi можно получить доступ к электронным базам данных
                (Электронная библиотека диссертаций, КонсультантПлюс, Гарант,
                Национальная электронная библиотека и многие другие).
              </div>
            </div>
            <div className="list-item">
              <div>
                <div className="icon-pc" />
              </div>
              <div>
                Комфортное пространство с книгами, периодикой, компьютерами и
                wi-fi. Здесь можно работать, читать, отдыхать, смотреть кино,
                слушать музыку, а также по предварительной договоренности
                провести фотосессию или снять видеоклип.
              </div>
            </div>
            <div className="list-item">
              <div>
                <div className="icon-event" />
              </div>
              <div>
                Множество самых разных культурных, просветительских и
                образовательных событий.
              </div>
            </div>
            <div className="list-item">
              <div>
                <div className="icon-time" />
              </div>
              <div>
                Удобный график работы: взрослые библиотеки открыты со вторника
                по субботу 10:00 до 22:00, а в воскресенье — до 20:00. Время
                работы может меняться в зависимости от профиля библиотеки и
                территориального расположения. Смотрите подробное расписание
                библиотек на карте.
              </div>
            </div>
          </div>
        </div>
        <Controls />
        <FavoriteLibraries />
        <div className="information-table feedback">
          <div>
            Поделитесь своими впечатлениями от посещения библиотек Москвы! Это
            поможет нам стать лучше. Пожалуйста, заполните короткую анкету из
            трех вопросов. Опрос анонимный.
          </div>
          <a
            href="https://ru.surveymonkey.com/r/BIBLIOPROS"
            target="_blank"
            rel="noreferrer noopener"
            className="arrow"
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  banner_top: state.banner_top.data
});

const mapDispatchToProps = dispatch => ({
  getTopBanner: bindActionCreators(banner_top.actions.getTopBanner, dispatch)
});

export default withWrapper(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Main)
);



// WEBPACK FOOTER //
// ./src/containers/Main/Main.js